import { render, staticRenderFns } from "./PaxReverse.vue?vue&type=template&id=3ee5e641&"
import script from "./PaxReverse.vue?vue&type=script&lang=js&"
export * from "./PaxReverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports